import { Box, Text } from "@chakra-ui/layout";
import { Trans } from "@lingui/macro";
import { currency } from "@src/utils/formatters";
import { Fragment } from "react";
import type { TooltipProps } from "recharts";

type Props = {
  type: "project" | "client";
} & TooltipProps<number, "value">;

export const TopGraphTooltipContent = ({ payload, active, type }: Props) => {
  const payloadsPayload = payload?.[0]?.payload;
  return (
    <Box p="2" bg="#212B36" zIndex="toast" rounded="md">
      <Text fontWeight="bold" color="white" mb="2">
        {type === "project" ? <Trans>Project:</Trans> : <Trans>Client:</Trans>}
        &nbsp;{payloadsPayload?.title ?? ""}
      </Text>
      {active && payload && (
        // biome-ignore lint/complexity/noUselessFragments: Created visual bugs without it
        <Fragment>
          {payload.map((load, index) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: Payload has no unique identifier
            <Text key={index} color={load.color}>
              {load?.name ?? ""}:&nbsp;
              {currency.formatByWorkspace(load?.value ?? 0)}
            </Text>
          ))}
        </Fragment>
      )}
      <Text color="white" mt="2">
        <Trans>Total:</Trans>&nbsp;
        {payloadsPayload?.total_value_formatted ?? 0}
      </Text>
    </Box>
  );
};
